import React from 'react';
import PropTypes from "prop-types";
import { stringify } from 'qs';
import intl from "react-intl-universal";
import Button from '../../../Common/Button';
import CardItem from '../CardItem';
import List from '../../Common/ListLayout';
import Empty from '../Empty';
import common from '../../../../common/common';
import { categoryMap } from '../../../../common/category';
import exchange from '../../../../common/exchange';
import {Commun} from "../../../../utils/axios";
import styles from './index.module.scss';

/**
 * 佩戴 / 取消佩戴
 * @param productInfo {Object} 商品信息
 * @param isCancel {Boolean} 是否取消佩戴
 */
export const onDress = (productInfo = {}, isCancel = false, categoryId = -1, dressData = [], onDataChange = () => {}) => {
    const { organizationId, itemId, systemItemId, expiredTs, permanent } = productInfo;
    Commun.post(`${common.starApiPrefix}/user/dress`, stringify({
        organizationId,
        itemId,
        categoryId,
        systemItemId,
        expiredTs, // 有效期
        permanent, // 是否永久有效
        isCancel
    }), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }).then(res => {
        if (!dressData || dressData.length <= 0) return;
        const data = [...dressData];
        if (!isCancel) {
            // 佩戴
            for (let item of data) {
                item.dressed = item.itemId === itemId;
            }
        } else {
            // 取消佩戴
            const index = data.findIndex(item => item.itemId === itemId);
            data.splice(index, 1, {
                ...data[index],
                dressed: false
            });
        }
        typeof onDataChange === 'function' && onDataChange(data);
    }).catch(error => {
        console.log(error);
    });
};

class Module extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        category: categoryMap['avatar'],
        data: [],
        onDataChange: null,
        getList: null
    };

    static propTypes = {
        category: PropTypes.number, // 兑换类型 1-头像框  2-弹幕框  3-视频框  4-实物奖励
        data: PropTypes.array, // 我的兑换列表
        onDataChange: PropTypes.func, // 数据改变后的回调
        getList: PropTypes.func  // 获取列表
    };

    componentDidMount() {
    }

    // 点击兑换
    onExchange = (productInfo = {}) => {
        exchange.onExchange({
            productIds: [productInfo.itemId],
            onComplete: this.props.getList
        });
    };

    /**
     * 将时间戳转化为时间
     * @param  timeStamp {Number}  传入的时间戳
     */
    formatDateTime = (timeStamp) => {
        const date = new Date(timeStamp * 1);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        if(month < 10) month = '0' + month;
        let day = date.getDate();
        day < 10 && (day = '0' + day);
        return `${year}/${month}/${day}`;
    };

    getContent = (item) => {
        const isGift = item.category === categoryMap['gift']; // 是否是实物奖励

        // 描述
        const description =
            isGift ? intl.get('EXCHANGED_TIMES', {time: item.purchasedNum}) :
                (
                    item.permanent ? intl.get('PERMANENT') : `${intl.get('VALID_UNTIL')} ${this.formatDateTime(item.expiredTs)}`
                );

        // hover弹窗内容
        const hoverContent =
            isGift ? null :
                <div className={styles.usedBtn}>
                    {
                        // item.expired ? <Button type="primary" onClick={() => this.onExchange(item)}>{intl.get('EXCHANGE')}</Button> :
                        item.expired ? null :
                            (
                                !item.dressed ? <Button type="primary" onClick={() => onDress(item, false, this.props.category, this.props.data, this.props.onDataChange)}>{intl.get('DRESS')}</Button> :
                                    <Button onClick={() => onDress(item, true, this.props.category, this.props.data, this.props.onDataChange)}>{intl.get('CANCEL_DRESS')}</Button>
                            )
                    }
                </div>;

        // 角标
        let label = { visible: false };
        if (!isGift && item.expired) {
            // 已过期
            label = {
                visible: true,
                style: {
                    background: '#CCC',
                    color: '#666'
                },
                text: intl.get('EXPIRED')
            }
        } else if (!isGift && item.dressed) {
            // 已佩戴(实物奖励不展示佩戴角标)
            label = {
                visible: true,
                style: {
                    background: '#1B934F',
                    color: '#D5FFE7'
                },
                text: intl.get('USED')
            }
        };

        return <CardItem
            cover={item.imageUrl}
            title={item.itemName}
            starValue={item.starValue}
            description={description}
            label={label}
            hoverable={!isGift && !item.expired}
            hoverContent={hoverContent}
        />
    };


    render() {
        const {
            category,
            data
        } = this.props;

        let categoryText = '',
            listColumns = common.isPhone() ? 2 : 3, // 一行展示几列
            listClassName = '';  // 类名
        switch(category) {
            case categoryMap['avatar']:
                // 头像框
                categoryText = intl.get('MINE_AVATAR');
                listClassName = styles.avatarList;
                break;
            case categoryMap['subtitles']:
                // 弹幕框
                categoryText = intl.get('MINE_SUBTITLES');
                listClassName = styles.subtitlesList;
                break;
            case categoryMap['video']:
                // 视频框
                categoryText = intl.get('MINE_VIDEO');
                listClassName = styles.videoList;
                break;
            case categoryMap['gift']:
                // 实物奖励
                categoryText = intl.get('MINE_GIFT');
                listClassName = styles.giftList;
                break;
        }

        return (
            <div className={styles.moduleItem}>
                <p className={styles.title}>{`${categoryText}（${data.length}）`}</p>
                <div className={styles.content}>
                    {
                        data.length ?
                            <List
                                loading={false}
                                columns={listColumns}
                                data={data}
                                className={listClassName}
                                getContent={this.getContent}
                            />
                            :
                            <Empty
                                category={category}
                                text={intl.get('EMPTY_EXCHANGE_LIST')}
                            />

                    }
                </div>
            </div>
        )
    }
}
export default Module;